import type { ReactNode } from 'react';

export const symbol_detector_battery: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-180h400v-160H320v160Zm-110 60q-12 0-21-9t-9-21v-220q0-12.75 9-21.38 9-8.62 21-8.62h540q12.75 0 21.38 8.62Q780-382.75 780-370v60h30.18q12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v40q0 12.75-8.62 21.37Q822.75-210 810-210h-30v60q0 12.75-8.62 21.37Q762.75-120 750-120H210Zm-30-660v60h600v-60H180Zm121 120 18 60h322l18-60H301Zm18 120q-19.5 0-35.25-11.63Q268-563.25 262-582l-25-78h-57q-24.75 0-42.37-17.63Q120-695.25 120-720v-60q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v60q0 24.75-17.62 42.37Q804.75-660 780-660h-57l-30 81q-6.93 17.25-22.34 28.12Q655.26-540 636-540H319ZM180-780v60-60Z"
		/>
	</svg>
);
